import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { IconSize } from '../../IconWrap';
import TierIcon16 from '../../16x16/Tier';
import TierIcon24 from '../../24x24/Tier';
import TierIcon32 from '../../32x32/Tier';
import PremiumDownloadIcon16 from '../../16x16/PremiumDownload';
import PremiumDownloadIcon24 from '../../24x24/PremiumDownload';
import PremiumDownloadIcon32 from '../../32x32/PremiumDownload';
import PremiumGalleryIcon16 from '../../16x16/PremiumGallery';
import PremiumGalleryIcon24 from '../../24x24/PremiumGallery';
import PremiumGalleryIcon32 from '../../32x32/PremiumGallery';
import CommissionBrushIcon16 from '../../16x16/CommissionBrush';
import CommissionBrushIcon24 from '../../24x24/CommissionBrush';
import CommissionBrushIcon32 from '../../32x32/CommissionBrush';
import SaleIcon16 from '../../16x16/Sale';
import SaleIcon24 from '../../24x24/Sale';
import SaleIcon32 from '../../32x32/Sale';
const iconsByType = {
    tier: {
        [IconSize.SMALLER]: TierIcon16,
        [IconSize.MEDIUM]: TierIcon24,
        [IconSize.LARGE]: TierIcon32
    },
    commission: {
        [IconSize.SMALLER]: CommissionBrushIcon16,
        [IconSize.MEDIUM]: CommissionBrushIcon24,
        [IconSize.LARGE]: CommissionBrushIcon32
    },
    premium_gallery: {
        [IconSize.SMALLER]: PremiumGalleryIcon16,
        [IconSize.MEDIUM]: PremiumGalleryIcon24,
        [IconSize.LARGE]: PremiumGalleryIcon32
    },
    adoptable: {
        [IconSize.SMALLER]: SaleIcon16,
        [IconSize.MEDIUM]: SaleIcon24,
        [IconSize.LARGE]: SaleIcon32
    },
    pcp: {
        [IconSize.SMALLER]: PremiumDownloadIcon16,
        [IconSize.MEDIUM]: PremiumDownloadIcon24,
        [IconSize.LARGE]: PremiumDownloadIcon32
    }
};
const MonetizationPromoIcon = (_param)=>{
    var { promoType, size } = _param, props = _object_without_properties(_param, [
        "promoType",
        "size"
    ]);
    const SelectedIcon = iconsByType[promoType][size];
    return /*#__PURE__*/ React.createElement(SelectedIcon, _object_spread({
        size: size
    }, props));
};
MonetizationPromoIcon.displayName = 'MonetizationPromoIcon';
export default MonetizationPromoIcon;
